<template>
  <div :style="'height:'+height+'px;width:'+width+'px;'" v-if="data_finished">
    <div class="left" :style="'height:'+height+'px;width:445px;overflow:auto;float: left'">
      <div
        class="menu_top"
        :style="'height:'+(side2_menu_height - (project_update_count > 0?0:20))+'px;'"
      >
        <div style="text-align: left;">
          <span class="category_btn typeSelected" @click="add_audit">新建审批</span>
        </div>

        <div v-if="init_list">
          <el-input v-model="search_word" placeholder="请输入审批名称"></el-input>
          <span
            class="category_btn selected_btn"
            :class="{'search_selected':total}"
            @click="selecteProjectList('total')"
          >全部</span>
          <span
            class="category_btn selected_btn"
            :class="{'search_selected':getDataParam.my_approval}"
            @click="selecteProjectList('my_approval')"
          >我审批</span>
          <span
            class="category_btn selected_btn"
            :class="{'search_selected':getDataParam.my_create}"
            @click="selecteProjectList('my_create')"
          >我发起</span>
          <div>
            <span
              class="category_btn selected_btn"
              :class="{'search_selected':getDataParam.underway}"
              @click="selecteProjectList('underway')"
            >进行中</span>
            <span
              class="category_btn selected_btn"
              :class="{'search_selected':getDataParam.is_finish}"
              @click="selecteProjectList('is_finish')"
            >已完成</span>
            <span
              class="category_btn selected_btn"
              :class="{'search_selected':getDataParam.is_failure}"
              @click="selecteProjectList('is_failure')"
            >审批失败</span>
            <span
              class="category_btn selected_btn"
              :class="{'search_selected':getDataParam.is_correct}"
              @click="selecteProjectList('is_correct')"
            >我已审批</span>
            <!-- <span
              class="category_btn selected_btn"
              :class="{'search_selected':getDataParam.is_abend}"
              @click="selecteProjectList('is_abend')"
            >已终止</span>-->
          </div>
          <div style="font-size: 12px; line-height: 20px;word-spacing: 3px;">
            <!--<img src="../assets/add_file.png" style="width: 20px;height: auto;vertical-align: middle;">-->
            <div style="color:red;cursor: pointer;">
              <span
                :class="{'is_approval_bt':getDataParam.is_approval}"
                @click="is_approval_list"
              >待审批数量:{{approval_counts}}</span>
              <!-- <span v-if="approval_counts < 10" class="approvalCounts">{{approval_counts}}</span>
              <span
                v-if="approval_counts > 10 && approval_counts < 99"
                class="approvalCounts approvalCounts2"
              >{{approval_counts}}</span>
              <span v-if="approval_counts > 99" class="approvalCounts approvalCounts3">99+</span>-->
            </div>
            <div style="color:#6fa1d4; ">共{{projectsItemShow.length}}条记录</div>
          </div>
        </div>
      </div>
      <div
        :style="'height:'+ (height - side2_menu_height + (project_update_count > 0?0:20)) +'px;overflow: auto'"
      >
        <el-menu>
          <el-submenu index="1" :key="index+''" v-for="(item,index) in projectsItemShow">
            <template slot="title">
              <div
                @click="show_project_detail(item.id)"
                :class="'project_item ' + (approval_id == item.id ? 'project_selected_audting':'')"
              >
                <div class="audit_name">{{index+1}}.{{item.name}}({{item.status}})</div>
                <!--{{index+1}}.{{item.name}}&nbsp; &nbsp; 234433-->
                <!--<div class="warpper_update" v-if="item.has_update"><span class="icon_update">有更新</span></div>-->
                <div>{{item.type}}</div>
                {{item.department}} {{item.user}}/ {{item.create_time}}
                <!-- <span class="icon_update fr" v-if="item.has_update">有更新</span> -->
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div :style="'height:'+height+'px;width:'+(width - 450) +'px;float: left; '">
      <router-view
        v-if="is_router_alive"
        :height="height"
        :width="width - 450"
        :web_token="web_token"
        :user_info="user_info"
        :web_url="web_url"
        :get_approval="get_approval"
      ></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      side2_menu_height: 220,
      search_word: "",
      user_info: {},
      limits: 10,
      selected: "document_selected",
      project_data: {},
      web_token: "",
      projectsList: { list: [], count: "" },
      approval_id: "",
      name: "",
      limit: 1,
      done: false,
      init_list: false,
      is_join: false,
      is_leader: false,
      is_manage: true,
      total: false,
      lists: { list: [], count: 0 },
      appUrl: "",
      // show_ellipsis:false,
      project_update_count: 0,
      is_update: false,
      total: true,
      projectsItemShow: [],
      is_router_alive: true,
      data_finished: false,
      approval_counts: 99,
      getDataParam: {
        limits: 1000,
        my_approval: false,
        my_create: false,
        underway: false,
        is_finish: false,
        is_failure: false,
        is_correct: false,
        is_abend: false,
        is_approval: false
      }
    };
  },
  props: ["height", "width"],
  // store,
  methods: {
    backToLogin() {
      this.$router.push("/login");
    },
    reload: function() {
      this.is_router_alive = false;
      this.$nextTick(function() {
        this.is_router_alive = true;
      });
    },
    // 审批详情
    show_project_detail(id) {
      this.approval_id = id;
      this.$router.push({
        path: "/main/auditing/auditing_detail/" + id,
        query: { id: id }
      });
      this.reload();
    },
    // 创建新项目
    add_audit() {
      this.$router.push({ path: "/main/auditing/auditing_create" });
      this.approval_id = "";
    },
    //获取审批
    get_approval: function() {
      this.getDataParam.web_token = this.web_token;
      this.$http
        .post(this.web_url + "/approval", this.getDataParam, {
          emulateJSON: true
        })
        .then(function(res) {
          if (res.data.status == "ok") {
            // 首次进入页面 如果数据为0 不显示搜索框
            if (res.data.data.list.length > 0) {
              this.init_list = true;
            }
            this.projectsList = res.data.data;
            this.data_finished = true;
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //退出登录
    loginout: function() {
      this.$http
        .post(
          this.web_url + "/logout",
          { web_token: this.web_token, system: "web", model_id: "6" },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            sessionStorage.removeItem("user_info");
            sessionStorage.removeItem("web_token");
            this.$router.push({ path: "/login" });
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //  获取审批数量
    approval_count() {
      this.$http
        .post(
          this.web_url + "/approval/count",
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          this.approval_counts = res.data.data.approval_count;
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    is_approval_list() {
      this.getDataParam.is_approval = this.getDataParam.is_approval
        ? false
        : true;
      this.get_approval();
    },
    //筛选项目
    selecteProjectList(type) {
      if (type == "total") {
        this.total = true;
        this.search_word = "";
        this.getDataParam = {
          limits: 1000,
          my_approval: false,
          my_create: false,
          underway: false,
          is_finish: false,
          is_failure: false,
          is_correct: false,
          is_abend: false
        };
      } else {
        this.getDataParam[type] = !this.getDataParam[type];
        var is_total_selected = true;
        var is_total_unselected = true;
        // 是否全为未选
        for (var key in this.getDataParam) {
          console.log(this.getDataParam[key]);
          if (this.getDataParam[key] && key != "web_token" && key != "limits") {
            is_total_unselected = false;
            console.log(is_total_unselected);
            break;
          }
        }
        // 是否全为已选
        for (var key in this.getDataParam) {
          if (
            !this.getDataParam[key] &&
            key != "web_token" &&
            key != "limits"
          ) {
            is_total_selected = false;
            break;
          }
        }
        if (is_total_unselected || is_total_selected) {
          this.total = true;
          this.getDataParam = {
            limits: 1000,
            my_approval: false,
            my_create: false,
            underway: false,
            is_finish: false,
            is_failure: false,
            is_correct: false,
            is_abend: false
          };
        } else {
          this.total = false;
        }
      }
      this.get_approval();
    }
  },
  computed: {},
  mounted() {},
  created() {
    this.web_token = sessionStorage.getItem("web_token");
    this.user_info = JSON.parse(sessionStorage.getItem("user_info"));
    this.web_url = sessionStorage.getItem("web_url");

    if (this.$route.query.id != undefined) {
      var that = this;
      that.approval_id = parseInt(that.$route.query.id);
    }

    this.get_approval();
    this.approval_count();
    // this.get_approval('');
  },
  watch: {
    projectsList: {
      handler(newName, oldName) {
        var that = this;
        this.projectsItemShow = [];
        for (var i = 0; i < that.projectsList.list.length; i++) {
          if (this.search_word != "") {
            if (this.projectsList.list[i].name.indexOf(this.search_word) > -1) {
              this.projectsItemShow.push(this.projectsList.list[i]);
            }
          } else {
            this.projectsItemShow.push(this.projectsList.list[i]);
          }
          // });
        }
      },
      immediate: true
    },
    search_word: function() {
      this.projectsItemShow = [];
      for (var i = 0; i < this.projectsList.list.length; i++) {
        if (this.projectsList.list[i].name.indexOf(this.search_word) > -1) {
          this.projectsItemShow.push(this.projectsList.list[i]);
        }
      }
    }
  }
};
</script>

<style scoped>
.left {
  background-color: #eeeeee;
  padding: 0 0 0 5px;
}
.approvalCounts {
  display: inline-block;
  width: 16px;
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  background: #ff0000;
  color: #fff;
  font-weight: bold;
  text-align: center;
  border-radius: 12px;
}
.approvalCounts2 {
  width: 22px;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
}
.approvalCounts3 {
  width: 22px;
  height: 22px;
  line-height: 22px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/page/auditing/home.vue